<template>
  <div class="col-sm-12 nopads">
    <div class="white-bg">
        <h3 class="editor-header">{{ editOld ? $t('subcontractors.edit') : $t('subcontractors.add_new') }}</h3>
      <div v-if="applicationUpdate.can_approve" class="row px-3 pb-2">
        <application-form :application="application" />
      </div>
      <!-- Editor -->
      <div v-else-if="applicationUpdate">
        <div class="row">
            <div class="col-sm-4">
                <span class="search-title">{{ $t('subcontractors.name') }}</span>
                <input
                    type="text"
                    v-model="applicationUpdate.subcontractor_name"
                    :placeholder="$t('subcontractors.name')"
                    class="form-control form-control-sm"
                    :disabled="!!loading || applicationUpdate.can_approve"
                />
            </div>

            <div class="col-sm-4">
                <span class="search-title">{{ $t('subcontractors.business_id') }}</span>
                <input
                    type="text"
                    v-model="applicationUpdate.subcontractor_business_id"
                    :placeholder="$t('subcontractors.business_id')"
                    class="form-control form-control-sm"
                    :disabled="!!loading || applicationUpdate.can_approve"
                />
            </div>

            <div class="col-sm-4">
                <span class="search-title">{{ $t('subcontractors.customer') }}</span>
                <select
                    v-model="customer"
                    class="form-select form-select-sm"
                    :disabled="!!loading || applicationUpdate.can_approve"
                >
                    <option :value="null">
                        {{ $t('subcontractors.select_customer') }}
                    </option>
                    <option
                        v-for="customer in customers"
                        :key="customer.id"
                        :value="customer.id"
                    >
                        {{ customer.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
          <span class="search-title pl-3">
            {{ $t('subcontractors.time_range') }}
          </span>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <input
                    id="start"
                    type="date"
                    :value="timestampToDateInput(applicationUpdate.time_from)"
                    class="form-control form-control-sm"
                    :disabled="applicationUpdate.can_approve"
                    @blur="updateStartDate"
                />
            </div>

            <div class="col-sm-4">
                <input
                    id="start"
                    type="date"
                    :value="timestampToDateInput(applicationUpdate.time_to)"
                    class="form-control form-control-sm"
                    :disabled="applicationUpdate.can_approve"
                    @blur="updateEndDate"
                />
            </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <span class="search-title">
              {{ $t('orders.info') }}
            </span>
              <textarea
                  id="info"
                  v-model="applicationUpdate.info"
                  rows="3"
                  class="form-control form-control-sm"
                  :style="{ 'max-height': 'calc(1.5em * 6)' }"
              />
          </div>
        </div>
      </div>
      <div class="col-sm-12 d-flex justify-content-end my-2">
        <button
          class="btn btn-secondary form-button"
          size="sm"
          @click.stop="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          v-if="!applicationUpdate.can_approve"
          class="btn btn-success form-button"
          :disabled="!!loading"
          @click.stop="onSubmit"
        >
          {{ editOld ? $t('common.edit') : $t('common.send') }}
        </button>
        <button
          v-if="applicationUpdate.can_approve"
          class="btn btn-danger form-button"
          :disabled="!!loading || !applicationUpdate.can_approve"
          @click.stop="handleApplication(2)"
        >
          {{ $t('work_permission.reject') }}
        </button>
        <button
          v-if="applicationUpdate.can_approve"
          class="btn btn-success form-button"
          :disabled="!!loading || !applicationUpdate.can_approve"
          @click.stop="handleApplication(1)"
        >
          {{ $t('work_permission.accept') }}
        </button>
      </div>
    </div>
    <div
      v-if="!!loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import ApplicationForm from "@/components/subcontractors/ApplicationForm";
import {inject} from "vue";

export default {
    name: "ApplicationEditor",
    components: {ApplicationForm},
    mixins: [restApi, timeUtils],
    props: {
        application: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            applicationUpdate: this.application,
            customer: null,
            customers: [],
            loading: 0
        }
    },
    computed: {
        editOld: function () {
            return this.applicationUpdate && this.applicationUpdate.id > 0
        }
    },
    watch: {
        customer: function (value) {
            this.applicationUpdate.customer = value ? {id: value} : null
        }
    },
    mounted() {
        this.customer = this.applicationUpdate.customer ? this.applicationUpdate.customer.id : null
        this.fetchCustomers()
    },
    methods: {
        fetchCustomers: function () {
            this.loading++
            this.vehicleOptions = []
            this.restFetch(this.customerUrl, this.handleCustomers)
        },
        handleCustomers: function (response) {
            if (response && response.data) {
                this.customers = response.data
            }
            this.loading--
        },
        onSubmit: function () {
            let validated = this.validateInput(this.applicationUpdate)
            if (validated !== undefined) {
                this.loading++
                if (!this.editOld) {
                    this.restAdd(this.subcontractorApplicationUrl, validated, this.addSuccess, this.fail)
                } else {
                    this.restUpdate(this.subcontractorApplicationUrl, validated, this.addSuccess, this.fail)
                }
            }
        },
        handleApplication: function (approval) {
            let validated = this.validateInput(this.applicationUpdate)
            if (validated !== undefined) {
                this.loading++
                validated.approval = approval
                this.restUpdate(this.subcontractorApplicationUrl, validated, this.addSuccess, this.fail)
            }
        },
        validateInput: function (application) {
            if (!application.customer || application.customer.id < 0) {
                this.showAlert(this.$t('subcontractors.error_customer'))
                return undefined
            }
            if (!application.subcontractor_name || !application.subcontractor_business_id ) {
                this.showAlert(this.$t('subcontractors.error_subcontractor_data'))
                return undefined
            }
            if (!application.time_to) {
                this.showAlert(this.$t('subcontractors.error_time_range'))
                return undefined
            }
            if (!application.time_from) {
                this.showAlert(this.$t('subcontractors.error_time_range'))
                return undefined
            }
            return application
        },
        addSuccess: function () {
            this.loading--
            this.$emit('update')
        },
        fail: function () {
            this.loading--
            if (!this.editOld) {
                this.showAlert(this.$t('common.alert_add_failed'))
            } else {
                this.showAlert(this.$t('common.alert_update_failed'))
            }
        },
        selectContract: function (id, update = true) {
            if (!this.editOld || (this.editOld && update)) {
                this.noteUpdate.order.id = -1
            }
        },
        updateStartDate: function (event) {
            if (event.target.value) {
                this.applicationUpdate.time_from = (new Date(event.target.value)).toISOString()
            } else {
                this.applicationUpdate.time_from = undefined
            }
        },

        updateEndDate: function (event) {
            if (event.target.value) {
                this.applicationUpdate.time_to = (new Date(event.target.value)).toISOString()
            } else {
                this.applicationUpdate.time_to = undefined
            }
        },
    }
}
</script>
<style>
.strong {
    font-weight: bold;
}
</style>
